import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PayableNotesCardForLoad } from 'pages';
import {
  AddModalButton,
  Circle,
  CorrectionsModal,
  Line,
  NoYet,
  SimpleModal,
  FullTable, Items,
} from 'components';
import {
  Colors,
  FindLoad,
  Images,
  PermissionsList,
  RolePermission,
  useGlobalStyles,
  useGlobalText,
  useModal,
} from 'utils';
import { CollectDebt } from '../paymentVerificationTable/core/collectDebt';
import { httpRequestsOnSuccessActions, loadActions, LoadServices } from 'store';
import { ACTION_TYPE, PAID, paymentVerBody, paymentVerHead, PMT_VERIFICATION } from './constants';
import { paymentVerificationDetailsStyle } from './styles';
import { PmtVerificationRows } from './pmtVerificationRows';
import { CANCELLED, PAYABLE } from '../../../pages/accounting/constants';
import { SendRemittanceDocument } from './sendRemittanceDocument';
import { payableNotesPriorities } from '../../../pages/accounting/payables/constants';
import { PayableNotes } from '../../../pages/accounting/payables/payableNotes';
import { PayableStatusEnum } from '../../common';

export const PaymentVerificationDetails = ({ loadById }) => {
  const { pastPayable } = useSelector((state) => ({
    pastPayable: state.loads.pastPayable,
  }));
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalText();
  const classes = paymentVerificationDetailsStyle();
  const dispatch = useDispatch();
  const loader = FindLoad('APPROVE_PAYABLE');
  const [openCorrection, setOpenCorrection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [correction, setCorrection] = useState('');
  const [openCollect, setOpenCollect] = useState(false);
  const { open, close } = useModal();
  const checkCorrection = loadById?.payable?.notes;

  const pNotesFiltered = [...loadById?.payable?.pNotes || []].sort((a, b) => {
    return payableNotesPriorities.indexOf(a.urgency) - payableNotesPriorities.indexOf(b.urgency);
  });


  useEffect(() => {
    dispatch(loadActions.getPastPayable(loadById?.id));
  }, []);

  const handleApprove = () => {
    dispatch(loadActions.approvePayable(loadById?.id, 'byId'));
  };

  const handleSend = async () => {
    setLoading(true);
    try {
      const date = { 'correction': correction };
      await LoadServices.PayableCorrections(loadById.id, date);
      dispatch(loadActions.getLoadById(loadById.id, 'noLoad'));
      dispatch(httpRequestsOnSuccessActions.appendSuccess('CORRECTION_SENDED'));
      setLoading(false);
      setOpenCorrection(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <div className={globalStyles.spaceBetween}>
          <div style={{ width: '100%' }} className={globalStyles.centerItem}>
            <Circle number={1} back={Colors.ThemeAqua} />
            <p className={globalText.title}>Active Payables</p>
          </div>
        </div>
        <div className={globalStyles.flexAndFullWidth}>
          <div className={'MuiAccordionDetails-root'}>
            <Line height={'auto'} />
          </div>
          {loadById?.payable ?
            <div style={{ width: '100%' }}>
              <PmtVerificationRows loadById={loadById} classes={classes} />
              <>
                {checkCorrection &&
                  <div className={classes.warnWrapper}>
                    <img src={Images.warning} alt="icon" />
                    <div className={classes.text}>
                      <p style={{ fontWeight: 'bold' }}>Corrections:  &nbsp;</p>
                      <span>{loadById?.payable?.notes ? loadById?.payable?.notes : ''}</span>
                    </div>
                  </div>
                }

                <div className={classes.pmtButtonsWrapper}>
                  {loadById?.payable?.status === PMT_VERIFICATION && loadById?.status !== CANCELLED &&
                    <div className={globalStyles.centerItem}>
                      {!loadById?.doNotPay &&
                        <AddModalButton
                          loading={!!loader.length}
                          styles={{ width: '238px', marginRight: '24px' }}
                          handleClick={handleApprove}
                          text={'Approve'}
                        />
                      }

                      <button style={{ marginRight: '24px' }}
                              onClick={() => setOpenCorrection(!openCorrection)}
                              className={classes.requestCorrection}
                      >
                        Request Corrections
                      </button>
                    </div>
                  }
                  {loadById?.payable?.status === PMT_VERIFICATION && loadById?.carrier?.debt?.length > 0 && loadById?.status !== CANCELLED &&
                    <AddModalButton
                      color={'blue'}
                      styles={{ width: '238px' }}
                      handleClick={() => setOpenCollect(!openCollect)}
                      text={'Collect'}
                    />
                  }
                  {(loadById.payable.status === PAID || loadById.payable.status === PAYABLE) &&
                    <div className={classes.sendCarrierEmailWrapper}>
                      <div className={classes.sendCarrierEmailImg}>
                        <img src={Images.FileSvg} alt="file" />
                      </div>

                      <p className={classes.sendCarrierEmailText}>
                        Remittance Document
                      </p>

                      <button
                        className={classes.sendCarrierReEmailButton}
                        onClick={() => open(<SendRemittanceDocument loadById={loadById} />)}
                      >
                        Send to the Carrier Email
                      </button>
                    </div>
                  }
                </div>
              </>
            </div>
            :
            <NoYet position={'screenCenter'} text={'No Payable Found'} />
          }
        </div>
      </div>
      <div>
        <div style={{ marginBottom: '24px' }} className={globalStyles.centerItem}>
          <div className={globalStyles.centerItem}>
            <Circle number={2} back={Colors.ThemeAqua} />
            <p className={globalText.title}>Past Payables</p>
          </div>
        </div>
        <div className={classes.pastTable}>
          <div>
            <FullTable
              head={paymentVerHead}
              body={paymentVerBody}
              loadingType={ACTION_TYPE}
              list={pastPayable}
              listCount={[]}
              noText={'Payable History'}
              margin={true}
              height={'small'}
            />
          </div>
        </div>
      </div>

      {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYABLE?.code]) &&
        <div>
          <div style={{ marginTop: '24px' }} className={globalStyles.centerItem}>
            <div className="align-justify-center" style={{ width: '100%', justifyContent: 'space-between' }}>
              <div className={globalStyles.centerItem}>
                <Circle number={3} back={Colors.ThemeAqua} />
                <p className={globalText.title}>Notes</p>
              </div>

              {(RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code])
                  && (loadById?.payable?.status === PayableStatusEnum.PAYABLE || loadById?.payable?.status === PayableStatusEnum.PENDING_PAYABLE)) &&
                <button
                  onClick={() => {
                    open(
                      <PayableNotes
                        load={loadById}
                        closeModel={close}
                        afterSuccess={() => dispatch(loadActions.getLoadById(loadById.id, 'noLoad'))}
                      />,
                      { noPadding: true, noCloseButton: true },
                    );
                  }}
                  className="blue-btn-with-circle"
                  style={{ marginRight: '14px' }}
                >
                  <img src={Images.addPlusBlueCircle} alt="add" />
                  <span>Add Note</span>
                </button>
              }
            </div>
          </div>
          <div className={classes.pastTable}>
            <div style={{
              maxHeight: 300,
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              overflowY: 'auto',
              marginTop: '24px',
              scrollbarColor: '#E4E7EC white',
            }}>
              {!!pNotesFiltered?.length && pNotesFiltered?.map((item, index) => (
                <PayableNotesCardForLoad
                  key={index}
                  item={item}
                  load={loadById}
                  afterSuccess={() => dispatch(loadActions.getLoadById(loadById.id, 'noLoad'))}
                />
              ))}
            </div>
          </div>
        </div>
      }

      <SimpleModal
        handleOpenClose={() => setOpenCollect(!openCollect)}
        openDefault={openCollect}
        content={
          <CollectDebt
            handleClose={() => setOpenCollect(!openCollect)}
            data={loadById}
          />
        }
      />
      <SimpleModal
        handleOpenClose={() => setOpenCorrection(!openCorrection)}
        openDefault={openCorrection}
        content={
          <CorrectionsModal
            handleChangeText={(e) => setCorrection(e)}
            loadingCor={loading}
            handleSend={handleSend}
            type={'notVerified'}
            handleClose={() => setOpenCorrection(!openCorrection)}
          />
        }
      />
    </div>
  );
};